import { type ReactElement } from 'react'
import * as S from './faq-card.styled'
import { type FaqCardProps } from './faq-card.props'

export function FaqCard ({ icon, text, title, href }: FaqCardProps): ReactElement {
  return <S.Container>
    <figure>
      <img src={icon} alt="" />
    </figure>
    <S.Content>
      <a href={href}><h3>{title}</h3></a>
      <p>{text}</p>
    </S.Content>
  </S.Container>
}
